import { render, staticRenderFns } from "./DashboardDonations.vue?vue&type=template&id=d62a65de"
import script from "./DashboardDonations.vue?vue&type=script&lang=js"
export * from "./DashboardDonations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports